import { WALLET_EXPERIMENT_KEY } from "core/constants/experiments";
import {
  useFeatureFlag,
  UseFeatureFlagResult,
} from "core/hooks/useFeatureFlag";

export type UseWalletFeatureFlagResult = UseFeatureFlagResult;

/**
 * Returns wallet feature flag state: { enabled, isLoading }.
 * Thin wrapper over useFeatureFlag — exists so the wallet CTA task has a named,
 * typed import rather than using a raw string key directly.
 * Adding the next feature flag: useFeatureFlag(NEXT_EXPERIMENT_KEY). No new files.
 */
export function useWalletFeatureFlag(): UseWalletFeatureFlagResult {
  return useFeatureFlag(WALLET_EXPERIMENT_KEY);
}
